import { languageMap } from ".."

languageMap.gcode = {
	comments: {
		line: ";",
	},
}
